import { css } from "lit"

export const highlighted = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
	}

	.highlighted-single {
	  width: 100%;
		height: auto;
	}


	@media screen and (max-width: 1030px) {
		.post-list {
			gap: 1.25rem;
		}

		highlighted-single {
			width: 100%;
		}


	}`
  
  export const highlightedSingle = css`
  .container {
		border-radius: 0.3125rem;
		display: flex;
		justify-content: flex-end;
		align-items: flex-start;
		overflow: hidden;
		position: relative;
		container-name: single-post;
		box-sizing: border-box;
		width: 100%;
		gap: 15%;
		overflow: auto;
		max-width: 79rem;
	}

	.left-aligned {
		flex-direction: row;
}

.right-aligned {
	flex-direction: row-reverse;
}

.container .img-container {
	width: 50%;
	border-radius: 0.3125rem;
	flex-grow: 1;
	min-height: 400px;
	display: flex;
	align-items: stretch;
}

.container img {
	width: 100%;
	height: 100%;
	object-fit: contain;
	border-radius: 0.3125rem;
	min-height: 400px;
}

.container .content-container {
	width: 50%;
}

.container h2 {
	font-family: var(--headings-font-family);
	font-size: 3.125rem;
	color: var(--e-global-color-primary);
	line-height: 120%;
	margin: 0;
	text-transform: uppercase;
	font-weight: 400;
}

.button-container {
margin-top: 2.5rem;
display: flex;
gap: 0.5rem;
}

.button-container a {
	text-transform: uppercase;
}

.button-container .filled {
	padding: 0.875rem 2rem;
	background: var(--e-global-color-primary);
	color: var(--e-global-color-secondary);
	font-family: var(--headings-font-family);
	font-size: 1.25rem;
	border-radius: 0.5rem;
	text-decoration: none;
}

.button-container .filled:hover {
	background: linear-gradient(142deg, #031227 3.72%, #08316D 59.15%, #031227 120.93%), #0C479D;
}

.button-container .outline {
	padding: 0.875rem 2rem;
	background: transparent;
	color: var(--e-global-color-primary);
	font-family: var(--headings-font-family);
	font-size: 1.25rem;
	border: 0.125rem solid var(--e-global-color-primary);
	border-radius: 0.5rem;
	text-decoration: none;
}

.button-container .outline:hover {
	background: var(--e-global-color-secondary);
}

@media screen and (max-width: 1030px) {
	.left-aligned {
		flex-direction: column;
	}

	.right-aligned {
		flex-direction: column;
	}

	.container .img-container {
		width: 100%;
	}
	
	.container .content-container {
		width: 100%;
	}

	.button-container {
		flex-direction: column;
	}

	.button-container a {
	text-align: center;
	}
}
`